/// <reference path="../../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(true)
    export class AgentComparisonAssignedConversationDialog extends Serenity.TemplatedDialog<ProductPickerOptions> {

        private checkGrid: AgentComparisonAssignedConversationGrid;
        public agentId: number;
        public agentNm: string;
        constructor(/*opt: ProductPickerOptions*/) {
            super(/*opt*/);
        }

        protected getTemplate() {
            return `<div id="~_RoomGrid"></div>`;
        }

        protected getDialogButtons() {
            //return [
            //    {
            //        text: Q.text("Dialogs.OkButton"),
            //        click: () => {
            //            //var selected = this.checkGrid.selectedItems;
            //            //if (!selected.length) {
            //            //    Q.notifyWarning("Please select some contact!");
            //            //    return;
            //            //}

            //            //if (!this.onSuccess || this.onSuccess(selected))
            //            //    this.dialogClose();
            //        }
            //    },
            //    {
            //        text: Q.text("Dialogs.CancelButton"),
            //        click: () => {
            //            this.dialogClose();
            //        }
            //    }
            //];
            return [];
        }

        //get selectedItems() {
        //    return this.checkGrid.selectedItems;
        //}
        protected onDialogOpen() {
            super.onDialogOpen();
            this.element.closest('.ui-dialog').find('.ui-dialog-titlebar-maximize').click();
            this.checkGrid = new AgentComparisonAssignedConversationGrid(this.byId("RoomGrid")/*, opt*/);
            this.checkGrid.ReById = this.agentId;
            this.dialogTitle = "Assigned Conversation by " + this.agentNm;
        }
        public onSuccess: (selected: string) => boolean;
    }
}